import { Reveal, Overline } from "@/components/site/ui";
import { LeadForm } from "@/components/site/LeadForm";
import { PROCESS, IMAGES } from "@/data/content";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const PERKS = [
  "Free photoreal 3D concept of your home",
  "Transparent, itemised pricing — no hidden costs",
  "Dedicated designer & project manager",
  "45-day delivery promise & 10-year warranty",
];

export default function BookConsultation() {
  return (
    <section className="relative min-h-screen bg-[#1C1A17] text-white overflow-hidden">
      <img
        src={IMAGES.heroLiving}
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-15"
      />
      <div className="absolute inset-0 bg-[#1C1A17]/70" />

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10 pt-36 pb-24 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <Overline dark>Book Free Design Consultation</Overline>
            <h1 className="font-head text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter mt-6 leading-[1.02]">
              Your dream home starts with a free conversation.
            </h1>
            <p className="mt-6 max-w-md text-white/65 text-lg leading-relaxed">
              No obligation, no pressure. Just great design advice and a photoreal 3D concept of your
              space — completely free.
            </p>
          </motion.div>

          <div className="mt-10 space-y-4">
            {PERKS.map((p, i) => (
              <Reveal key={p} delay={i * 0.08}>
                <div className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/10">
                    <Check className="h-4 w-4 text-white" />
                  </span>
                  <span className="text-white/80">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-5 gap-2">
            {PROCESS.map((p) => (
              <div key={p.no} className="text-center">
                <div className="font-head text-lg text-white/40">{p.no}</div>
                <div className="mt-1 text-[10px] sm:text-xs text-white/60">{p.title}</div>
              </div>
            ))}
          </div>
        </div>

        <Reveal delay={0.15}>
          <div className="rounded-3xl bg-white/[0.04] backdrop-blur-xl border border-white/10 p-8 lg:p-10">
            <h2 className="font-head text-2xl font-medium">Request your free consultation</h2>
            <p className="text-white/50 text-sm mt-2">We’ll respond within 24 hours.</p>
            <div className="mt-8">
              <LeadForm source="consultation" ctaLabel="Book My Free Consultation" dark />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
